import { ROUTES } from "@/constants";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically
  const { pathname } = useLocation();

  return (
    <footer className="w-full mt-2 px-4">
      <div
        className={`z-9 w-full flex-col sm:flex-row flex justify-center px-8 rounded-[8px] ${
          pathname === ROUTES.APP_ROOT ? "pt-6 !mx-0 bg-golden-10" : "bg-white"
        } text-monochrome-100 text-center text-xs py-5`}
      >
        <p className="text-monochrome-100 text-center text-xs leading-none">© {currentYear} Penomo B.V.</p>
      </div>
    </footer>
  );
};

export default Footer;
